import { EsRequestPetitions } from "@edp-models/ES/es-petitions.model";
import {
    ESRequestsOperationsList,
    EsRequestOperations,
    IEsRequestsOperationsFilter,
    IInterventionDateES,
} from "@edp-models/ES/es-request-operatios.model";
import { ServiceES } from "@edp-models/ES/es-service.model";
import { INewRequestAndOperationES } from "@edp-pages/ES/request-and-operations-es/services-es/new-request-es.service";
import { Action } from "@ngrx/store";

export enum ERequestsAndOperationsESActions {
    GetRequestsAndOperations = "[RequestsAndOperations] Get Requests and Operations",
    SetRequestsAndOperations = "[RequestsAndOperations] Set Requests and Operations",
    GetAvailableTimeSlots = "[RequestsAndOperations] Get Available Time Slots",
    SetAvailableTimeSlots = "[RequestsAndOperations] Set Available Time Slots",
    AvailableTimeSlotsAPIError = "[RequestsAndOperations] Set Available Time Slots Api Error",
    SetFilters = "[RequestsAndOperations] Set Filters",
    EsSelectFilters = "[RequestsAndOperations] Select Filters",
    SetLoadedRequestsAndOperations = "[RequestsAndOperations] Set Loaded RequestsAndOperations",
    SetLocalSupportList = "[RequestsAndOperations] Set First Load RequestsAndOperations",
    SetAssociatedContract = "[RequestsAndOperations] Set Associated contract to RequestsAndOperations",
    EsGetServices = "[RequestsAndOperations] Get Services ES",
    EsSetServices = "[RequestsAndOperations] Set Services ES",
    SetLoadedServices = "[RequestsAndOperations] Set Loaded Services",
    SetLoadedSlots = "[RequestsAndOperations] Set Loaded Slots",
    GetAvailable = "[RequestsAndOperations] Get RequestsAndOperations",
    GetRequestsAndOperationsDetails = "[RequestsAndOperations] Get Requests And Operations Details",
    SetRequestsAndOperationsDetails = "[RequestsAndOperations] Set Requests And Operations Details",
    EsSetNewRequest = "[RequestsAndOperations] Set New Request",
    SetSelectedServiceAndMotive = "[RequestsAndOperations] Set Selected Service and Motive",
    GetSelectedServiceAndMotive = "[RequestsAndOperations] Get Selected Service and Motive",
    SetNewRequestStatus = "[RequestsAndOperations] Set New Request Status",
    GetNewRequestStatus = "[RequestsAndOperations] Get New Request Status",
    SetMotiveId = "[RequestsAndOperations] Set Motive Id",
}
export class SelectFiltersES implements Action {
    public readonly type = ERequestsAndOperationsESActions.EsSelectFilters;
    constructor(public args?: string) {}
}

export class SetFiltersES implements Action {
    public readonly type = ERequestsAndOperationsESActions.SetFilters;
    constructor(public payload: IEsRequestsOperationsFilter[]) {}
}

export class SetLoadedRequestsAndOperationsES implements Action {
    public readonly type = ERequestsAndOperationsESActions.SetLoadedRequestsAndOperations;
    constructor(public payload: boolean) {}
}

export class SetLoadedServicesES implements Action {
    public readonly type = ERequestsAndOperationsESActions.SetLoadedServices;
    constructor(public payload: boolean) {}
}

export class GetServicesES implements Action {
    public readonly type = ERequestsAndOperationsESActions.EsGetServices;
    constructor(public payload: string) {}
}

export class SetServicesES implements Action {
    public readonly type = ERequestsAndOperationsESActions.EsSetServices;
    constructor(public payload: ServiceES[]) {}
}

export class SetLocalSupportListES implements Action {
    public readonly type = ERequestsAndOperationsESActions.SetLocalSupportList;
    constructor(public payload: boolean) {}
}

export class SetAssociatedContractES implements Action {
    public readonly type = ERequestsAndOperationsESActions.SetAssociatedContract;
    constructor(public payload: number) {}
}

export class SetRequestsAndOperationsES implements Action {
    public readonly type = ERequestsAndOperationsESActions.SetRequestsAndOperations;
    constructor(public payload: EsRequestPetitions[]) {}
}

export class GetRequestsAndOperationsES implements Action {
    public readonly type = ERequestsAndOperationsESActions.GetRequestsAndOperations;
    constructor(public payload: ESRequestsOperationsList) {}
}

export class AvailableTimeSlotsAPIErrorES implements Action {
    public readonly type = ERequestsAndOperationsESActions.AvailableTimeSlotsAPIError;
    constructor(public error: Error) {}
}

export class SetLoadedSlotsES implements Action {
    public readonly type = ERequestsAndOperationsESActions.SetLoadedSlots;
    constructor(public payload: boolean) {}
}

export class SetAvailableTimeSlotsES implements Action {
    public readonly type = ERequestsAndOperationsESActions.SetAvailableTimeSlots;
    constructor(public payload: IInterventionDateES[]) {}
}

export class SetRequestsAndOperationsDetailsES implements Action {
    public readonly type = ERequestsAndOperationsESActions.SetRequestsAndOperationsDetails;
    constructor(public payload: EsRequestOperations) {}
}

export class SetSelectedServiceAndMotiveES implements Action {
    public readonly type = ERequestsAndOperationsESActions.SetSelectedServiceAndMotive;
    constructor(public payload: INewRequestAndOperationES) {}
}

export class SetNewRequestStatusES implements Action {
    public readonly type = ERequestsAndOperationsESActions.SetNewRequestStatus;
    constructor(public payload: any) {}
}

export class SetNewRequestES implements Action {
    public readonly type = ERequestsAndOperationsESActions.EsSetNewRequest;
    constructor(public payload: any) {}
}

export type RequestsOperationsESActions =
    | GetRequestsAndOperationsES
    | SetRequestsAndOperationsES
    | SetAssociatedContractES
    | SetLocalSupportListES
    | SetLoadedRequestsAndOperationsES
    | SelectFiltersES
    | SetLoadedServicesES
    | GetServicesES
    | SetFiltersES
    | SetServicesES
    | AvailableTimeSlotsAPIErrorES
    | SetLoadedSlotsES
    | SetAvailableTimeSlotsES
    | SetRequestsAndOperationsDetailsES
    | SetSelectedServiceAndMotiveES
    | SetNewRequestStatusES
    | SetNewRequestES;
